import { useAvailableProvidersSettingsQuery } from 'core/graphql/Settings/AvailableProvidersSettings.generated';
import { ProviderInfo } from 'core/graphql/types';

type AvailableProvidersResult = {
  defaultItineraryProviders: ProviderInfo[];
  courierDesignedItineraryProviders: ProviderInfo[];
  areProvidersLoading: boolean;
};

const useAvailableProvidersDataStore = (): AvailableProvidersResult => {
  const { data, loading } = useAvailableProvidersSettingsQuery();
  if (data !== undefined) {
    return {
      defaultItineraryProviders: data.DefaultItineraryProviders,
      courierDesignedItineraryProviders: data.CourierDesignItineraryProviders,
      areProvidersLoading: loading,
    };
  }

  return {
    defaultItineraryProviders: [],
    courierDesignedItineraryProviders: [],
    areProvidersLoading: false,
  };
};

export default useAvailableProvidersDataStore;
